@if(team){
  <main class="container-fluid main-page settings">
    <div class="settings-sub-header w-100 pt-4 pb-3 border-0">
      <div class="d-md-flex justify-content-between">
        <h1 class="team-selector">
          <div class="team-selector-label">
            {{'teamSetting' | translate}}
          </div>
          <tm-team-select baseUrl="/setup/team"
            permission="admin"
            [teamIdFromUrl]="teamId"
          [teams]="teams"></tm-team-select>
          <small class="d-block pt-3">{{ 'teamSetting_description' | translate }}.</small>
        </h1>
        <div class="d-flex align-items-md-center">
          <button class="btn btn-primary px-4 mb-1 align-top" (click)="openNewTeamDialog()" data-cy="add-team" title="{{'create_team' | translate}}">
            <span class="add-member-btn"><i class="far fa-plus"></i>&nbsp;{{('newTeam' | translate)}}</span>
          </button>
        </div>
      </div>
    </div>

    <hr class="border-top border-secondary border-1 opacity-25 my-0">

    <form class="form-horizontal p-3 pt-4">
      <div class="form-group row mb-4">
        <label class="col-form-label col-md-3" for="teamName">{{'teamName' | translate}}</label>
        <div class="col-md-4">
          @if(!editName){
            <div class="p-2">
              <span class="fs-5">{{team.name}}</span> <span class="text-link ms-3" (click)="editName=true"><i class="far fa-pen"></i> {{'edit' | translate}}</span>
            </div>
          }
          @else{
          <div class="pt-2">
            <input type="text" id="teamName" name="teamName" class="form-control"
              [(ngModel)]="team.name"
              autofocus>
            <div class="text-end pt-1">
              <button class="btn btn-sm edit-btn edit-btn-save me-1" (click)="saveTeamName()">{{'orgUnits_save' | translate}}</button>
              <button class="btn btn-sm btn-default edit-btn" (click)="editName=false">{{'orgUnits_cancel' | translate}}</button>
            </div>
          </div>
        }
      </div>
    </div>

    <div class="form-group row mb-4">
      <label class="col-form-label col-md-3" for="ous">{{'orgUnits' | translate}}</label>
      <div class="col-md-4 pe-0">
        <table class="table table-condensed table-org-units" id="ous">
          @if (orgUnits.length > 0) {
            <tbody>
              @for (ou of orgUnits; track ou) {
                <tr class="position-relative org-unit-table-row">
                  <td class="org-unit-table-cell">{{ou.ou.type}}</td>

                  <td class="org-unit-table-cell">
                    @if(!ou.updateMode){
                      <div class="org-unit-table-cell">
                        <span>{{ou.ou.name}}</span>
                      </div>
                    }
                    @else{
                    <org-unit-name-table-cell [orgUnit]="ou.ou"
                      [availableOrgUnitNames]="availableOrgUnitNames"
                    (orgUnitUpdateEvent)="onUpdateOrgUnit($event)"></org-unit-name-table-cell>
                  }

                </td>
                @if(!ou.updateMode && ou.ou.type !== 'Organization'){
                  <td class="org-unit-action">
                    <button class="btn btn-sm btn-default me-1" (click)="updateOrgUnit(ou)"><i class="fa-solid fa-pen"></i></button>
                    <button class="btn btn-sm btn-danger" (click)="removeOrgUnit(ou.ou)"><i class="fa-solid fa-trash-can"></i></button>
                  </td>
                }
              </tr>
            }

          </tbody>
        }
      </table>
      <span class="text-link" (click)="createOrgUnit()" [hidden]="!!createMode">+ {{'orgUnits_add' | translate}}</span>
    </div>

    @if(createMode){
      <div class="p-2 col-md-6 mx-auto row">
        <div class="bg-light p-3 ms-1 col-md-8">
          <p>{{'orgUnits_add_desc' | translate}}</p>
          <org-unit-selector (orgUnitCreateEvent)="onCreateOrgUnit($event)"></org-unit-selector>
        </div>
        <p class="help-block w-25 ms-3 px-0 col-md-4"><small><i class="fa-regular fa-square-info"></i> {{'orgUnits_definition'  |  translate}}</small></p>
      </div>
    }
  </div>

  <div class="row">
    <div class="col-md-3"></div>
    <p class="col-md-6 mb-4 ps-2 pt-3 text-secondary">
      <i class="fa-regular fa-square-info"></i> {{'team_created_on' | translate}} {{team.creationDate}}@if (team.creator) {
      <span> {{'by' |  translate}} {{team.creator}}</span>
    }
  </p>
</div>


<hr class="mt-5 pt-5">
<div class="form-group row">
  <label class="col-form-label col-md-3" for="deleteTeam">{{'danger_zone' | translate}}</label>
  <div class="col-md-4">
    <p [hidden]="!!team.is_deletable" id="helpBlock" class="help-block"><small>{{ team.cant_delete_cause | translate}}</small></p>
    <button type="button" class="btn btn-danger" [disabled]="!team.is_deletable" id="deleteTeam" (click)="deleteTeam(team)">
      <i class="fal fa-trash-alt"></i> {{'delete_team' | translate}}
    </button>
  </div>
</div>
</form>
</main>
}
